<template>
  <div>
    <navbar/>
    <container/>
  </div>
</template>

<script>
import Nav from "../../Nav";
import Container from "./TermoResponsabilidadeContainerLista"
export default {
  name: "TermoResponsabilidadeLista",
  components: {
    "navbar": Nav,
    "container": Container
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/termoResponsabilidade/TermoResponsabilidadeLista.vue